//React Components and Hooks
import React from "react";
//Material UI functions
import { useTheme } from "@mui/styles";
//Material UI Components
import Chip from "@mui/material/Chip";
import { getChipVariant } from '../../utils/chipStyles';

const FailureChip = (props) => {
  const theme = useTheme();
  const chipProps = getChipVariant('error', theme);

  return (
    <Chip 
      label={props.text} 
      {...chipProps}
      size="small" 
    />
  );
};
export default FailureChip;
